




























import EmptyMessage from '@/components/EmptyMessage.vue'
import PageFilters from '@/components/PageFilters.vue'
import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'

const gtm = namespace('gtm')

/**
 * @displayName ListView
 * filters, empty-message, infinite-loading을 포함한 list component
 */
@Component({
  components: {
    PageFilters,
    EmptyMessage,
  },
})
export default class ListView extends Vue {
  @Prop({default: true, type: Boolean}) visiblePageFilter: boolean
  /**
   * PageFilters props
   */
  @Prop({default: 0, type: Number}) totalCount: number
  @Prop({default: true, type: Boolean}) visibleRefresh: boolean
  @Prop() filterItemList: object[]
  @Prop({default: false, type: Boolean}) disabledFilters: boolean
  /**
   * EmptyMessage props
   */
  @Prop() emptyMessage: string[]
  @Prop({default: 'empty', type: String}) emptyStatus: string
  @Prop({default: false, type: Boolean}) visibleEmptyMessage: boolean
  /**
   * Infinite scroll visible value
   */
  @Prop({default: false, type: Boolean}) visibleInfiniteScroll: boolean
  /**
   * Infinite loading visible value
   */
  @Prop({default: false, type: Boolean}) loading: boolean
  @Prop({default: 0, type: Number}) windowScrollY: number

  @gtm.Action('logEventWithGroups') logEventWithGroups:
    (payload: LogEventWidthGroupsPayload) => void

  get isScrollToBottom() {
    return this.windowScrollY >= (document.body.scrollHeight - window.innerHeight)
  }

  @Watch('isScrollToBottom', {immediate: true})
  __isScrollToBottom(value) {
    if(value && this.visibleInfiniteScroll) {
      /**
       * Emit infinite scroll event
       */
      this.$emit('infinite-scroll')
    }
  }
  /**
   * Emit refresh button click
   */
  onClickRefresh() {
    this.logEventWithGroups({
      eventType: 'refresh_list',
      eventProperties: {}
    })
    this.$emit('refresh')
  }
  /**
   * Emit filter items id
   */
  onClickFilerItem(id) {
    this.$emit(id)
  }

  /**
   * fill contents if contents less than window height
   */
  fillContents() {
    if(!this.hasScroll()) {
      this.$emit('infinite-scroll')
    }
  }

  hasScroll() {
    return document.body.scrollHeight > window.innerHeight
  }
}
